const Terms = () => {
  return (
    <div className="pt-24 pb-20">
      <div className="container mx-auto">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="mb-12">
            <h1 className="text-5xl md:text-6xl font-bold heading-font text-white mb-4">
              Terms of Service
            </h1>
            <p className="text-gray-400">Last updated: January 24, 2026</p>
            <div className="mt-4 p-4 bg-white/5 rounded-lg border border-white/10">
              <p className="text-sm text-gray-400">
                These Terms of Service are provided by <strong className="text-white">Limitly</strong>, a <strong className="text-white">Limited Liability Company</strong> registered in <strong className="text-white">New Mexico, United States</strong>.
              </p>
            </div>
          </div>

          {/* Content */}
          <div className="space-y-8 text-gray-300">
            <section>
              <h2 className="text-2xl font-bold heading-font text-white mb-4">1. Acceptance of Terms</h2>
              <div className="space-y-3 leading-relaxed">
                <p>
                  By accessing or using Limitly's services, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using our services.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold heading-font text-white mb-4">2. Description of Service</h2>
              <div className="space-y-3 leading-relaxed">
                <p>
                  Limitly provides a spend management platform that helps businesses control expenses, issue team cards, capture receipts, and maintain audit-ready financial records.
                </p>
                <p className="text-gray-400">
                  Limitly is not a bank. Card issuance and financial services are provided by licensed financial institution partners.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold heading-font text-white mb-4">3. User Accounts</h2>
              <div className="space-y-3 leading-relaxed">
                <p>
                  To use Limitly, you must create an account. You are responsible for:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4 text-gray-400">
                  <li>Maintaining the security of your account credentials</li>
                  <li>All activities that occur under your account</li>
                  <li>Providing accurate and complete information</li>
                  <li>Notifying us immediately of any unauthorized access</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold heading-font text-white mb-4">4. Acceptable Use</h2>
              <div className="space-y-3 leading-relaxed">
                <p>
                  You agree not to use Limitly to:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4 text-gray-400">
                  <li>Violate any applicable laws or regulations</li>
                  <li>Engage in fraudulent or illegal activities</li>
                  <li>Interfere with or disrupt the service</li>
                  <li>Attempt to gain unauthorized access to our systems</li>
                  <li>Use the service for any unauthorized commercial purpose</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold heading-font text-white mb-4">5. Fees and Payment</h2>
              <div className="space-y-3 leading-relaxed">
                <p>
                  Certain features of Limitly may require payment. You agree to pay all applicable fees as described in your subscription plan. Fees are non-refundable except as required by law.
                </p>
                <p className="text-gray-400">
                  We reserve the right to change our fees with reasonable notice.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold heading-font text-white mb-4">6. Card Services</h2>
              <div className="space-y-3 leading-relaxed">
                <p>
                  Virtual and physical cards are issued by our banking partners, subject to their terms and conditions. Card usage is subject to:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4 text-gray-400">
                  <li>Spending limits set by your organization</li>
                  <li>Merchant and category restrictions</li>
                  <li>Available funds in your account</li>
                  <li>Approval by our banking partners</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold heading-font text-white mb-4">7. Intellectual Property</h2>
              <div className="space-y-3 leading-relaxed">
                <p>
                  The Limitly service, including all content, features, and functionality, is owned by Limitly and is protected by copyright, trademark, and other intellectual property laws.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold heading-font text-white mb-4">8. Limitation of Liability</h2>
              <div className="space-y-3 leading-relaxed">
                <p>
                  To the maximum extent permitted by law, Limitly shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or relating to your use of the service.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold heading-font text-white mb-4">9. Termination</h2>
              <div className="space-y-3 leading-relaxed">
                <p>
                  We may terminate or suspend your account and access to the service at any time, with or without notice, for conduct that we believe violates these Terms or is harmful to other users, us, or third parties.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold heading-font text-white mb-4">10. Changes to Terms</h2>
              <div className="space-y-3 leading-relaxed">
                <p>
                  We reserve the right to modify these Terms at any time. We will notify you of any material changes by posting the new Terms on this page. Your continued use of the service after such changes constitutes acceptance of the new Terms.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold heading-font text-white mb-4">11. Governing Law</h2>
              <div className="space-y-3 leading-relaxed">
                <p>
                  These Terms shall be governed by and construed in accordance with the laws of the jurisdiction in which Limitly operates, without regard to its conflict of law provisions.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold heading-font text-white mb-4">12. Contact Information</h2>
              <div className="space-y-3 leading-relaxed">
                <p>
                  If you have any questions about these Terms, please contact us:
                </p>
                <div className="p-4 bg-white/5 rounded-lg border border-white/10">
                  <div className="space-y-2 text-gray-400">
                    <p><strong className="text-white">Limitly LLC</strong></p>
                    <p>Email: <a href="mailto:legal@limitly.org" className="text-indigo-400 hover:text-indigo-300 transition-colors">legal@limitly.org</a></p>
                    <p className="text-sm">
                      Address:<br />
                      LIMITLY LLC<br />
                      2105 Vista Oeste NW, Ste 3694<br />
                      Albuquerque, NM 87120<br />
                      United States
                    </p>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
